import script from "./SignatureCotainer.vue?vue&type=script&setup=true&lang=js"
export * from "./SignatureCotainer.vue?vue&type=script&setup=true&lang=js"

import "./SignatureCotainer.vue?vue&type=style&index=0&id=b4752be8&lang=css"

const __exports__ = script;

export default __exports__